// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePasswordForm-btnBig-VvBVl {
	padding: 13px 21px !important;
	width: 100%;
}

.ChangePasswordForm-pwdImage-TXCrU {
	position: absolute;
	top: 49px;
	right: 20px;
	cursor: pointer;
}

.ChangePasswordForm-root-PZDxH {
	border: 1px solid var(--primary-border) !important;
	padding: 30px;
	border-radius: 14px;
}

.ChangePasswordForm-titleText-Pxg7E {
	font-size: 22px;
	font-weight: 600;
	margin: 0px 0px 22px;
}`, "",{"version":3,"sources":["webpack://./src/components/ForgotPassword/ChangePasswordForm/ChangePasswordForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kDAAkD;CAClD,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,oBAAoB;AACrB","sourcesContent":[".btnBig {\n\tpadding: 13px 21px !important;\n\twidth: 100%;\n}\n\n.pwdImage {\n\tposition: absolute;\n\ttop: 49px;\n\tright: 20px;\n\tcursor: pointer;\n}\n\n.root {\n\tborder: 1px solid var(--primary-border) !important;\n\tpadding: 30px;\n\tborder-radius: 14px;\n}\n\n.titleText {\n\tfont-size: 22px;\n\tfont-weight: 600;\n\tmargin: 0px 0px 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnBig": `ChangePasswordForm-btnBig-VvBVl`,
	"pwdImage": `ChangePasswordForm-pwdImage-TXCrU`,
	"root": `ChangePasswordForm-root-PZDxH`,
	"titleText": `ChangePasswordForm-titleText-Pxg7E`
};
module.exports = ___CSS_LOADER_EXPORT___;
